import { render, staticRenderFns } from "./NavigationDrawerList.vue?vue&type=template&id=51218b0c"
import script from "./NavigationDrawerList.vue?vue&type=script&lang=js"
export * from "./NavigationDrawerList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports